export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    id: 'faq-1',
    question: 'kaiyun com 是正版授权平台吗？',
    answer: '是的，kaiyun com 是经过官方认证的正版授权平台。我们持有完整的运营资质，严格遵守相关法律法规，致力于为用户提供安全、合规、优质的服务体验。您可以通过平台展示的授权标识和资质证明来验证我们的正版身份。',
  },
  {
    id: 'faq-2',
    question: '如何注册 kaiyun com 账号？',
    answer: '注册 kaiyun com 账号非常简单快捷。您只需点击平台首页的"注册"按钮，按照提示填写基本信息（如手机号码或邮箱地址），设置登录密码，完成验证后即可成功注册。整个过程通常在1分钟内即可完成。',
  },
  {
    id: 'faq-3',
    question: '平台的安全性如何保障？',
    answer: 'kaiyun com 采用银行级安全防护体系，包括TLS 1.3加密传输协议、多重身份验证机制、实时风控监控系统以及定期安全审计。我们严格遵守数据保护相关法规，确保每一位用户的隐私和数据安全得到全面保障。',
  },
  {
    id: 'faq-4',
    question: '遇到问题如何联系客服？',
    answer: '我们提供7×24小时全天候客服支持。您可以通过以下方式联系我们：1）在线客服：直接点击页面右下角的在线客服图标；2）官方邮箱：发送邮件至我们的客服邮箱；3）电话热线：拨打官方客服电话。我们的专业团队会在第一时间为您解决问题。',
  },
  {
    id: 'faq-5',
    question: '平台支持哪些功能和服务？',
    answer: 'kaiyun com 提供丰富的一站式服务，涵盖多个领域。具体功能包括但不限于：实时资讯浏览、分类内容探索、个性化推荐、账户安全管理、在线客服支持等。我们持续优化和丰富平台功能，以满足用户不断增长的需求。',
  },
  {
    id: 'faq-6',
    question: '忘记密码怎么办？',
    answer: '如果您忘记了登录密码，可以点击登录页面的"忘记密码"选项，按照系统提示通过绑定的手机号码或邮箱进行密码重置。整个过程安全快捷，如果您在重置过程中遇到任何问题，可随时联系在线客服获取帮助。',
  },
  {
    id: 'faq-7',
    question: 'kaiyun com 的最新地址在哪里可以找到？',
    answer: '为确保您始终访问的是正版 kaiyun com 平台，我们建议您将官方域名加入浏览器收藏夹。同时，您也可以关注我们的官方社交媒体账号或订阅邮件通知，我们将通过这些渠道第一时间发布最新的官方地址信息。请警惕仿冒网站，认准官方渠道。',
  },
  {
    id: 'faq-8',
    question: '平台的数据隐私政策是怎样的？',
    answer: 'kaiyun com 严格遵守数据隐私保护相关法律法规。我们制定了详尽的隐私政策，明确告知用户数据的收集范围、使用目的和保护措施。我们承诺：绝不向第三方出售或泄露用户个人信息，所有数据仅用于优化服务体验和保障平台安全。',
  },
];